// ======================
// Footer
// ======================

import { observer } from "mobx-react-lite";
import { Box, Theme, Link as MuiLink, Typography } from "@mui/material";
import React from "react";
import { EULALink, HelpCenterLink, PrivacyPolicyLink, TermsOfServiceLink, useNavigateToExternalLink } from "../help/HelpCommon";
import { LanguageMenu } from "../i18n/LanguageSelect";
import { useTranslation } from "react-i18next";

interface FooterProps {}

export const CirrusFooter: React.FC<FooterProps> = observer((p) => {
    const currentYear = new Date(Date.now()).getFullYear();
    const navigateToCirrusWebsite = useNavigateToExternalLink("https://www.cirrusdata.com/");
    const { t } = useTranslation();
    const separator = (
        <Box mx={1}>
            <Typography component={"span"} variant={"caption"}>
                {t("common:legal.separator")}
            </Typography>
        </Box>
    );
    return (
        <Box
            width={"100%"}
            sx={{
                padding: 2,
                //top: "auto",
                bottom: 0,
                //position: "fixed",
                backgroundColor: (t: Theme) => t.palette.cirrus.main,
                borderTop: "1px solid black",
                //boxShadow: "0px -1px 6px rgba(0,0,0,0.3)",
            }}
        >
            <Box display={"flex"} justifyContent={"center"} alignItems={"center"} flexWrap={"wrap"}>
                <Box>
                    <LanguageMenu />
                </Box>
                {separator}
                <Box>
                    <TermsOfServiceLink variant={"caption"} />
                </Box>
                {separator}
                <Box>
                    <PrivacyPolicyLink variant={"caption"} />
                </Box>
                {separator}
                <Box>
                    <EULALink variant={"caption"} />
                </Box>
                {separator}
                <Box>
                    <HelpCenterLink variant={"caption"} />
                </Box>
            </Box>
            <Box display={"flex"} justifyContent={"center"}>
                <MuiLink onClick={navigateToCirrusWebsite} color={"textSecondary"}>
                    <Typography variant={"caption"} color={"textSecondary"}>
                        © {currentYear} Cirrus Data Solutions Inc.
                    </Typography>
                </MuiLink>
            </Box>{" "}
        </Box>
    );
});
